export const paddingHorizontal = 16
export const paddingBottom = 8
